<template>
  <el-select ref="compSelect" v-bind="$attrs" v-on="$listeners" :remote="remote" :remote-method="query"
             :loading="loading" filterable clearable placeholder="请输入单位名称模糊查询"
             @change="onChange"
             style="width: 100%">
    <el-option v-for="item in items" v-bind:key="item.compId" :value="item.compId" :label="item.compName">
    </el-option>
  </el-select>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  extends: BaseVue,
  props: {
    remote: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      items: []
    }
  },
  created() {
    if(!this.remote) {
      this.loadData("");
    }
  },
  methods: {
    query(str) {
      // if(!str) {
      //   return;
      // }
      this.loadData(str);
    },
    loadData(str){
      this.loading = true;
      this.postForm("/company/getCompanyList", {
        compName: str
      }, true).then(dr => {
        this.items = dr.rows;
      }).finally(()=>{
        this.loading = false;
      });
    },
    //初始化显示
    init(comp) {
      this.$refs.compSelect.cachedOptions.push({
        currentLabel: comp.compName,
        currentValue: comp.compId,
        label: comp.compName,
        value: comp.compId
      })
    },
    onChange(v) {
      if(!v) {
        this.$emit("select", null);
      } else {
        const comp = this.items.find(item => item.compId === v);
        this.$emit("select", comp);
      }
    }
  }
}
</script>
